import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GeneralExperiencePage } from './general-experience';

@NgModule({
  declarations: [
    GeneralExperiencePage,
  ],
  imports: [
    IonicPageModule.forChild(GeneralExperiencePage),
  ],
})
export class GeneralExperiencePageModule {}



// WEBPACK FOOTER //
// ./src/pages/general-experience/general-experience.module.ts